const classContainer = '.owl-carousel-nav__thumbnail-gallery';
const classContainerInner = '.owl-carousel-nav__thumbnail-gallery-inner';
const classItem = '.owl-carousel-nav__item';
const classActive = '.owl-carousel-nav__active';
const classPrevButton = '.owl-carousel-nav__nav--previous';
const classNextButton = '.owl-carousel-nav__nav--next';

const $items = $(classItem);
const $btnPrev = $(classPrevButton);
const $btnNext = $(classNextButton);

const spacing = 10;
const itemCount = 3;

let index = 0;

function getPageCount() {
  return Math.max(0, $items.length) - itemCount;
}

function getHeight(itemCount) { // eslint-disable-line no-shadow
  const count = Math.min(itemCount, $items.length);
  return $items.outerHeight() * count;
}

function resize() {
  $(classContainer).css('height', `${getHeight(itemCount)}px`);
}

function toggleButtons() {
  const btnPrevActive = index !== 0;
  $btnPrev.attr('disabled', !btnPrevActive).toggleClass(classActive, btnPrevActive);

  const btnNextActive = index < getPageCount();
  $btnNext.attr('disabled', !btnNextActive).toggleClass(classActive, btnNextActive);
}

$items.css('padding', `${spacing}px 0`);

$btnPrev.click(function () {
  index = Math.max(0, index - 1);
  $(classContainerInner).css('top', `-${(1 / itemCount) * index * 100}%`);
  toggleButtons();
});

$btnNext.click(function () {
  index = Math.min(getPageCount(), index + 1);
  $(classContainerInner).css('top', `-${(1 / itemCount) * index * 100}%`);
  toggleButtons();
});

$(window).resize(resize);

$(document).ready(() => {
  toggleButtons();
  resize();
});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/vertical-gallery-scroll.js